// extracted by mini-css-extract-plugin
export default {"gradient-border":"GradientButton_gradient-border__gFE5U"};